import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { MsalProvider } from '@azure/msal-react';
import { EventMessage, PublicClientApplication } from '@azure/msal-browser';

import './i18n';
import setupInterceptors from './api-client/setup-axios';

import '@gaiads/telia-react-component-library/build/index.css';

import { msalConfig } from './authConfig';
import AppWrapper from './indexApp';
import { msalEventCallbackHandler } from './utils';
import VersionInfo from './VersionInfo';

export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => msalEventCallbackHandler(event, msalInstance));
setupInterceptors(msalInstance);

const VERSION_INFO_URL = '/version/info';
const container = document.getElementById('root');
const root = createRoot(container!);
if (window.location.pathname === VERSION_INFO_URL) {
  root.render(<VersionInfo />);
} else {
  root.render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <AppWrapper />
      </MsalProvider>
    </StrictMode>,
  );
}
